export var dtDesktopPrefix = 'dtd';
export var dtDesktopButtonPrefix = "".concat(dtDesktopPrefix, "-btn");
export var dtDesktopBadgePrefix = "".concat(dtDesktopPrefix, "-badge");
export var dtDesktopTabPrefix = "".concat(dtDesktopPrefix, "-tabs");
export var dtDesktopSegmentControlPrefix = "".concat(dtDesktopPrefix, "-seg");
export var dtDesktopSpinPrefix = "".concat(dtDesktopPrefix, "-spin");
export var EmptyPagePrefix = "".concat(dtDesktopPrefix, "-empty");
export var switchPrefix = "".concat(dtDesktopPrefix, "-switch");
export var tagPrefix = "".concat(dtDesktopPrefix, "-tag");
export var dropdownPrefixCls = "".concat(dtDesktopPrefix, "-dropdown");
export var tooltipPrefix = "".concat(dtDesktopPrefix, "-tooltip");
export var modalPrefixCls = "".concat(dtDesktopPrefix, "-modal");
export var breadcrumbPrefixCls = "".concat(dtDesktopPrefix, "-breadcrumb");
export var noticeBarPrefixCls = "".concat(dtDesktopPrefix, "-notice-bar");
export var toastPrefixCls = "".concat(dtDesktopPrefix, "-toast");
export var inputPrefix = "".concat(dtDesktopPrefix, "-input");
export var inputSearchPrefix = "".concat(dtDesktopPrefix, "-input-search");
export var inputGroupPrefix = "".concat(dtDesktopPrefix, "-input-group");
export var inputPasswordPrefix = "".concat(dtDesktopPrefix, "-input-password");
export var formPrefix = "".concat(dtDesktopPrefix, "-form");
export var datePickerPrefix = "".concat(dtDesktopPrefix, "-picker");
export var selectPrefix = "".concat(dtDesktopPrefix, "-select");
export var autoCompletePrefix = "".concat(dtDesktopPrefix, "-auto-complete");
export var radioPrefix = "".concat(dtDesktopPrefix, "-radio");
export var listPrefix = "".concat(dtDesktopPrefix, "-list");
export var searchBarPrefix = "".concat(dtDesktopPrefix, "-search-bar");
export var checkboxPrefix = "".concat(dtDesktopPrefix, "-checkbox");
export var iconPrefixCls = "".concat(dtDesktopPrefix, "-icon");
export var menuPrefixCls = "".concat(dtDesktopPrefix, "-menu");
export var inpageGuidePrefix = "".concat(dtDesktopPrefix, "-inpage-guide");
export var imagePrefix = "".concat(dtDesktopPrefix, "-image");
export var uploadPrefix = "".concat(dtDesktopPrefix, "-upload");
export var uploadListPrefix = "".concat(dtDesktopPrefix, "-upload-list");
export var tablePrefix = "".concat(dtDesktopPrefix, "-table");
export var paginationPrefix = 'dtd-pagination';
export var popoverPrefix = "".concat(dtDesktopPrefix, "-popover");
export var popconfirmPrefix = "".concat(dtDesktopPrefix, "-popconfirm");
export var skeletonPrefix = "".concat(dtDesktopPrefix, "-skeleton");
export var rowPrefix = "".concat(dtDesktopPrefix, "-row");
export var colPrefix = "".concat(dtDesktopPrefix, "-col");
export var treePrefix = "".concat(dtDesktopPrefix, "-tree");
export var cascaderPrefix = "".concat(dtDesktopPrefix, "-cascader");
export var drawerPrefix = "".concat(dtDesktopPrefix, "-drawer");
export var spacePrefix = "".concat(dtDesktopPrefix, "-space");
export var dividerPrefix = "".concat(dtDesktopPrefix, "-divider");
export var anchorPrefix = "".concat(dtDesktopPrefix, "-anchor");
export var progressPrefix = "".concat(dtDesktopPrefix, "-progress");
export var AffixPrefix = "".concat(dtDesktopPrefix, "-affix");
export var sliderPrefix = "".concat(dtDesktopPrefix, "-slider");
export var transferPrefix = "".concat(dtDesktopPrefix, "-transfer");
export var typographyPrefix = "".concat(dtDesktopPrefix, "-typography");
export var cardPrefix = "".concat(dtDesktopPrefix, "-card");
export var avatarPrefix = "".concat(dtDesktopPrefix, "-avatar");
export var notificationPrefix = "".concat(dtDesktopPrefix, "-notification");
export var statisticPrefix = "".concat(dtDesktopPrefix, "-statistic");
export var affixPrefix = "".concat(dtDesktopPrefix, "-affix");
export var stepsPrefix = "".concat(dtDesktopPrefix, "-steps");
export var resultPrefix = "".concat(dtDesktopPrefix, "-result");
export var inputNumberPrefix = "".concat(dtDesktopPrefix, "-input-number");
export var pageHeaderPrefix = "".concat(dtDesktopPrefix, "-page-header");
export var backTopPrefix = "".concat(dtDesktopPrefix, "-back-top");
export var carouselPrefix = "".concat(dtDesktopPrefix, "-carousel");
export var timelinePrefix = "".concat(dtDesktopPrefix, "-timeline");
export var descriptionsPrefix = "".concat(dtDesktopPrefix, "-descriptions");
export var layoutPrefix = "".concat(dtDesktopPrefix, "-layout");
export var commentPrefix = "".concat(dtDesktopPrefix, "-comment");
export var collapsePrefix = "".concat(dtDesktopPrefix, "-collapse");
export var ratePrefix = "".concat(dtDesktopPrefix, "-rate");